/*globals $*/
'use strict';

// Include base block
var Block = require('../libs/block');
var FormsetManager = require('../libs/django-formset-manager');

// Create new block
module.exports = Block.extend({
    template: '#manufacturer-editor',

    /**
     * Basic Block-initialization
     */
    init: function () {
        this.formsetManager = new FormsetManager($('#manufacturer-form'), {
            prefix: 'parcel_types'
        });
    }
});
